import { useState } from 'react';
import { useVinCodeService } from '../../services/vinCodeService';
import globalNotification from './globalNotification';
import { notificationType } from '../constants/notificationType';

export const useVinCode = ({ vinCode, t } = {}) => {
    const [code, setCode] = useState(vinCode);
    const [vinData, setVinData] = useState(null);
    const [error, setError] = useState('');
    const [language, setLanguage] = useState('en');
    const [isLoading, setIsLoading] = useState(false);

    const { decodeVin } = useVinCodeService();

    const handleInputChange = e => {
        const value = e.target.value;
        setCode(value);
        setError('');
    };

    const decodeVinData = async vin => {
        setIsLoading(true);

        try {
            const response = await decodeVin(vin);
            setVinData(response.data);
        } catch (error) {
            globalNotification.open({
                type: notificationType.ERROR,
                message: t('profile:notification.decode-error.message'),
                description: t('profile:notification.decode-error.description'),
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        code,
        vinData,
        error,
        handleInputChange,
        decodeVinData,
        setCode,
        setError,
        language,
        setLanguage,
        isLoading,
    };
};
